export const TRANSACTION_TYPES = {
    PAYMENT:1,
    RECEIVE:2,
}

export const TRANSACTION_NAMES = {
    [TRANSACTION_TYPES.PAYMENT]: "پرداخت",
    [TRANSACTION_TYPES.RECEIVE]: "دریافت",
};

export const IMPORT_DATA_FROM_FILE_STEPS = {
    IMPORT_EXCEL:"IMPORT_EXCEL",
    CREATE_MISSING_SUB_ITEMS:"CREATE_MISSING_SUB_ITEMS",
    FINAL_PREVIEW:"FINAL_PREVIEW",
}

export const TRANSACTION_IMPORT_FILE_STEP_KEY = "STEP"
export const TRANSACTION_IMPORT_FILE_UUID = "uuid"